import React, { useEffect, useState, useContext } from 'react';
import { where } from "firebase/firestore";
import { CommonCloudFirestore } from '../../../services/CommonCloudFirestore';
import { DOCUMENT_CATEGORY, LISTENER_CATEGORIES } from '../../../../shared/types/firestoreType';
import { ConfigurationContext } from '../../../../shared/context/ConfigurationContext';

import global from '../../../../shared/utility/global';
import storageManager from '../../../../shared/utility/storageManager';
import ExpandedItem from '../../../../shared/components/CategoryItem/ExpandedItem';
import IconItem from '../../../../shared/components/CategoryItem/IconItem';

export default function Index(props) {
    const categoryFirestore = new CommonCloudFirestore(DOCUMENT_CATEGORY);
    const configurationContext = useContext(ConfigurationContext);

    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        onLoad();
    }, []);

    const onLoad = async () => {
        setLoading(true);
        const condition = where("visible", "==", true);
        const _categories = await storageManager.fetch(LISTENER_CATEGORIES, async () => await categoryFirestore.getDocuments(condition));
        const sortCategories = _categories.sort(global.orderBy('index'));
        setCategories(sortCategories);
        setLoading(false);
    };

    if (categories?.length === 0)
        return null;

    return (
        <div className='mb-20'>
            <div className="p-3 mb-3 bg-light text-dark text-center">
                CATEGORÍAS
            </div>
            <div className="container">
                <div className='row justify-content-center pb-2 g-3'>
                    {
                        categories?.map((item) => {
                            if (configurationContext.data.category.display === 1)
                                return <IconItem key={item.id} item={item} />;

                            if (configurationContext.data.category.display === 2)
                                return <ExpandedItem key={item.id} item={item} />;

                            return <IconItem key={item.id} item={item} />;
                        })
                    }
                </div>
            </div>
        </div>
    );
}